var transformKeyObject = require('./modules/form-key-transform');
var buildSimulationPayloadBase = require('./modules/simulation-payload');
var { resolveSimulationStudentTown } = require('./modules/simulation-student-town');
var { formatCurrencyInputValue } = require('./modules/currency-input-format');
var { toggleBlockWithCondition, updateCommune, handleNumberOfPeople, setNameInputForm } = require('./modules/simulation-dom');

jQuery(function ($) {
    let _body = $('body');
    var locale = $('.section-aid').attr("data-locale");
    var tah_lang = false;
    var commune_locale = 'Commune';
    var logement_locale = "Logement souhaité";
    if(locale === 'tah') {
        tah_lang = true;
        commune_locale = "‘Oire";
        logement_locale = "Nohora’a tā ‘oe e hina’aro";
    }
    const LOTISSEMENTS_CITIES = [
        { value: 'CHE_Paraita', text: 'CHE Paraita' },
        { value: 'CHE_Outumaoro', text: 'CHE Outumaoro' }
    ];

    $('.aid-item.logement').hover(function(){
        $('#txt-avenir').removeClass('d-none');
        $('#txt-etudiant').addClass('d-none');
    }, function(){
        $('#txt-avenir').addClass('d-none');
        $('#txt-etudiant').removeClass('d-none');
    });
    $('.aid-item').on('click', function(){
        $('#txt-avenir').addClass('d-none');
        $('#txt-etudiant').removeClass('d-none');
    });
    $('.aid-item.logement').on('click', function(){
        $('#txt-avenir').removeClass('d-none');
        $('#txt-etudiant').addClass('d-none');
        return false;
    });

    // Init Tooltip
    $(function () {
        var help_info = "Si vous avez besoin d'aide, veuillez nous contacter au";
        var info_student_demande = "Cochez ici si vous êtes déjà locataire d’un CHE géré par l’OPH";
        var info_studant_city = "Choisir le CHE le plus proche de l'établissement scolaire";
        if (tah_lang) {
            help_info = "Mai te peu e hina’aro ‘oe i te tauturu, a niuniu mai i te";
            info_student_demande = "Cochez ici si vous êtes déjà locataire d’un CHE géré par l’OPH";
            info_studant_city = "Choisir le CHE le plus proche de l'établissement scolaire";
        }

        $('[data-toggle="tooltip"]').tooltip()

        $('.section-aid .icon-tooltip').tooltip(
            {
            template: "<div class='tooltip-container text-center'><p>"+help_info+"</p><a href='#'>40.46.36.36</a></div>",
            html: true
        })

        $('.section-form-title .icon-tooltip').tooltip({
            template: "<div class='tooltip-container text-center'><p>"+help_info+"</p><a href='#'>40.46.36.36</a></div>",
            html: true
        })
        $('.stud-demande .icon-tooltip').tooltip({
            template: "<div class='tooltip-container text-center'><p>"+info_student_demande+"</p></div>",
            html: true
        })
        $('.d-city .icon-tooltip').tooltip({
            template: "<div class='tooltip-container text-center'><p>"+info_studant_city+"</p></div>",
            html: true
        })
    })
    /**
     * -------------------------------
     *  STEP 1
     * -------------------------------
     */

    var simulation_type;

    /**
     * Function handle choose aid
     */

    let currentValue = {
        simulation_rmm: 0,
        simulation_pmm: 0
    }

    _body.on('click', '.btn-aid-item', function () {
        const _this = $(this);
        const id = _this.attr('id');
        simulation_type = id;
        $('#simulation_numberOfAdult,#simulation_numberOfChild').on("change", function() {
            handleNumberOfPeople(id);
        });

        $('.btn-aid-item').removeClass('active');
        _this.addClass('active');
        $('.section-form').removeClass('d-none');

        handleAidSelect(id);

        currentValue.simulation_rmm = 0;
        currentValue.simulation_pmm = 0;

        $('.form-group.bmd-form-group').removeClass('is-filled');

        // Scroll
        $([document.documentElement, document.body]).animate({
            scrollTop: $(".section-center.section-form").offset().top - 100
        }, 200);
    });

    /**
     * -------------------------------
     *  STEP 2
     * -------------------------------
     */

    // Init Select2 Condition Particulieres
    function InitSelecSimulattion() {
        var condition_locale = 'Conditions particulières';
        var student_profil_label = 'Profil';
        var student_log_label = 'Lieu';
        if (tah_lang){
            condition_locale = 'Tītaura’a ta’a ‘ē';
            student_profil_label = 'Profil';
            student_log_label = 'Lieu';
        }
        setTimeout(function(){
            $("select[name='simulation[particularConditions]']").select2({
                placeholder: condition_locale,
                minimumResultsForSearch: Infinity,
                // allowClear: true
            });

            // Init Select2 City
            $("select[name='simulation[town]']").select2({
                placeholder: commune_locale
            });

            // Init Select2 log_etudiant
            $("select[name='simulation[log_etudiant]']").select2({
                placeholder: student_log_label
            });

            // Init Select2 City
            $("select[name='simulation[student_profil]']").select2({
                placeholder: student_profil_label
            });
        }, 0)
    }
    InitSelecSimulattion();

    // Init Select2 Desired Accommodation
    $("select[name='desired_accommodation']").select2({
        placeholder: logement_locale,
        minimumResultsForSearch: Infinity,
        // allowClear: true
    });



    /**
     * Function helper: Hide blocks with condition type and show input value
     * @param {*} type
     * @param {*} condition
     */
    // toggleBlockWithCondition / updateCommune / handleNumberOfPeople : déplacés vers
    // modules/simulation-dom (dédup web/borne, cf. setNameInputForm plus bas).

    $('#simulation_numberOfAdult,#simulation_numberOfChild').on("change", function() {
        handleNumberOfPeople();
    });

    /**
     * Function handle Aid Select
     */
    function handleAidSelect(value) {
        toggleBlockWithCondition('aid', value);
        $('#simulation_numberOfAdult,#simulation_numberOfChild').val('');
        $(`.d-condition[data-type='number-people'][data-value='4']`).hide();
        InitSelecSimulattion();

        $('.text-attention-dialog').addClass('d-none');
        $('.d-student').addClass('d-none');
        $('.d-condition-student').removeClass('d-none');
        $('#simulation_submit').text('lancer la simulation');
        if (tah_lang) {
            $('#simulation_submit').text('HA’AMATA I TE FA’AHI’ORA’A');
        }
        switch (value) {
            case 'FAREOPH':
                commune_locale = "Commune de construction";
                if (tah_lang) {
                    commune_locale = "‘Oire i reira e patuhia";
                }
                updateCommune(commune_locale, undefined, LOTISSEMENTS_CITIES);
                var getValue = $("select[name='simulation[particularConditions]']").val();
                if(getValue === '2') {
                    $(`.d-condition[data-type='particular'][data-value='2']`).show();
                }
                $('#text-fareoph').removeClass('d-none');
                break;
            case 'AAHI':
                commune_locale = "Commune de livraison";
                if (tah_lang) {
                    commune_locale = "Oire i reira e fa’ahoro ai i te mau tauiha’a";
                }
                updateCommune(commune_locale, undefined, LOTISSEMENTS_CITIES);
                $(`.d-condition[data-type='particular'][data-value='2']`).hide();
                $('#text-aahi').removeClass('d-none');
                break;
            case 'LOTISSEMENTS':
                commune_locale = "Commune souhaitée";
                if (tah_lang) {
                    commune_locale = "‘Oire hina’arohia";
                }
                updateCommune(commune_locale, undefined, LOTISSEMENTS_CITIES);
                $(`.d-condition[data-type='particular'][data-value='2']`).hide();
                $('#text-lotissements').removeClass('d-none');
                break;
            case 'LOGEMENT_ETUDIANT':
                updateCommune(logement_locale, true, LOTISSEMENTS_CITIES);
                $('.d-condition-student').addClass('d-none');
                $('.d-student').removeClass('d-none');
                $('#simulation_submit').text('Constituer ma demande');
                if (tah_lang) {
                    $('#simulation_submit').text('Constituer ma demande');
                }
                break;
            default:
                break;
        }
        $('form[name="simulation"]').trigger('reset');
    }

    /**
     * Function handle particular select
     */

        $("select[name='simulation[particularConditions]']").on('change', function () {
            const _this = $(this);
            const _value = _this.val();
            toggleBlockWithCondition('particular', _value);
        })

    /**
     * Function handle input '-' or 'e' to input with [type='number']
     * 0 for null values
     * 8 for backspace
     * 48-57 for 0-9 numbers
     */
    $("input[type='number']").on("keypress", function (evt) {
        if (evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57) {
            evt.preventDefault();
        }
    });


    /**
     * Function handle number input for 'input-currency'
     */
    $(".input-currency, .input-number-person").on("keypress", function (evt) {
        if (evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57) {
            evt.preventDefault();
        }
    });


    $(".input-currency, .input-number-person").on("focus", function (evt) {
        const _this = $(this);
        const name = _this.attr('name');
        const _value = _this.val(); // input value
        if (currentValue[name] == 0 ) {
            _this.val(''); // empty
        } else {
            _this.val(currentValue[name]); // Load current value number
        }
    });

    /**
     * Function handle focusout 'input-currency'
     */
    $(".input-currency").on("focusout", function (evt) {
        const _this = $(this);
        const name = _this.attr('name');
        const _value = _this.val();
        if (!!_value && _value > 0) {
            currentValue[name] = _value; // Save current value

            _this.val(formatCurrencyInputValue(_value));
        } else {
            currentValue[name] = 0;
        }
    });

    var required_locale = "Ce champ est obligatoire.";
    if (tah_lang) {
        required_locale = "Mea fa’ahepo teie nei ārea."
    }
    /**
     * --------------------------------------------
     * Function handle validate form 'Simulation'
     * --------------------------------------------
     */
    jQuery.extend(jQuery.validator.messages, {
        required: required_locale
    });
    $("#form_simulation").validate({
        debug: true,
        highlight: function (element) {
            $(element).closest(".form-group").addClass("has-error");
        },
        unhighlight: function (element) {
            $(element).closest(".form-group").removeClass("has-error");
        },
        errorClass: "error",
        errorPlacement: function (error, element) {
            error.appendTo(element.closest(".form-group")); // replace error to closest '.form-group'
        },
        ignore: ":hidden:not(.hidden-required)", // ignore all hidden, except element have class 'hidden-required'
        rules: {
            person_with_reduced_mobility: {
                required: true,
            },
            victim_of_natural_disaster: {
                required: true,
            },
            particular_conditions: {
                required: true,
            },
            desired_accommodation: {
                required: true,
            },
            city: {
                required: true,
            },
            amount_of_adults: {
                required: true,
            },
            amount_of_children: {
                required: true,
            },
            average_revenue: {
                required: true,
            },
            monthly_mortgage_payment: {
                required: true,
            },

        }
    });

    /**
     * Function handle click btn submit
     */
    _body.on('click', '#form_simulation .btn-submit', function () {
        if (grecaptcha.getResponse() === "") {
            $(`.login-captcha-error`).removeClass("d-none");
        } else {
            $(`.login-captcha-error`).addClass("d-none");
            const _this = $(this);

            const isValid = $('#form_simulation').valid();

            if (isValid) {
                // Get Value serialize as Array
                let formArray = $('#form_simulation').serializeArray();
                const formObj = {};
                for (let i = 0; i < formArray.length; i++) {
                    formObj[formArray[i]['name']] = formArray[i]['value'];
                }
                calculateEligible(formObj);
                _this.addClass('d-none');
            }
        }
    });

    /**
     * Function helper calculate MEJ point
     */
    var sessionId;
    function calculateEligible(formObj) {

        var dataObject = transformKeyObject(formObj);
        var log_etudiant = parseInt(dataObject.simulation_log_etudiant) || 0;
        var town = resolveSimulationStudentTown(log_etudiant, parseInt(dataObject.simulation_town) || 0);
        // Champs de base communs web/borne extraits vers le module PUR testé simulation-payload.
        Object.assign(currentValue, buildSimulationPayloadBase(dataObject, simulation_type));
        // Champs spécifiques au parcours web (town avec surcharge log_etudiant + champs étudiant).
        currentValue.simulation_town = town;
        currentValue.student_demande = dataObject.simulation_student_demande;
        currentValue.student_profil = parseInt(dataObject.simulation_student_profil) || 0;
        currentValue.log_etudiant = log_etudiant;

        $.ajax({
            url: `/simulation/create`,
            type: "POST",
            dataType: "JSON",
            data: currentValue,
            success: function (data) {
                if (data.success === 'true' || data.success === true) {
                    if (data.isStudent === 'true' || data.isStudent === true) {
                        sessionId = data.sessionId;
                        goToResultStudent();
                    }else {
                        if (data.desactiver === true && data.isEligible) {
                            goToStep3Desactiver();
                        }else {
                            var isEligible = data.isEligible;
                            sessionId = data.sessionId;
                            goToStep3(isEligible);
                        }
                    }
                } else {
                    $('.simulation-error-text').html(data.error);
                    $('.simulation-error').removeClass('d-none');
                    $(".simulation-error").on('click', '.btn-reload', function () {
                        location.reload();
                    });
                }

            },
            error: function (err) {
                $('.simulation-error-text').html('Une erreur s\'est produite pendant la simulation.<br> Nous vous invitons à recommencer.');
                $('.simulation-error').removeClass('d-none');
                $(".simulation-error").on('click', '.btn-reload', function () {
                    location.reload();
                });
            }
        });
    }

    /**
     * -------------------------------
     *  STEP 3
     * -------------------------------
     */

    function cleanData() {
        // Clean Data
        $('.btn-aid-item').removeClass('active');
        $('.section-result').addClass('d-none');
        $('.section-result .result-panel.is-eligible').addClass('d-none');
        $('.section-result .result-panel.not-eligible').addClass('d-none');
        $('.section-form').addClass('d-none');
        $('#form_simulation').trigger("reset");
        $('#form_simulation .btn-submit').removeClass('d-none');
    }

    function goToStep3(isEligible) {
        $('.section-result').removeClass('d-none');

        if (isEligible) {
            $('.section-result .result-panel.is-eligible').removeClass('d-none');
        } else {
            $('.section-result .result-panel.not-eligible').removeClass('d-none');
        }


        // Scroll
        $([document.documentElement, document.body]).animate({
            scrollTop: $(".section-result").offset().top - 100
        }, 200);
    }

    function goToStep3Desactiver() {
        $('.section-result').removeClass('d-none');
        $('.section-result .result-panel.desactiver').removeClass('d-none');

        // Scroll
        $([document.documentElement, document.body]).animate({
            scrollTop: $(".section-result").offset().top - 100
        }, 200);
    }

    function goToResultStudent() {
        cleanData();
        $('.text-secondary').addClass('d-none');
        $('.text-secondary-student').removeClass('d-none');
        // Scroll top
        $([document.documentElement, document.body]).animate({
            scrollTop: $(".section-header").offset().top - 100
        }, 200);

        // Show Create Account Dialog
        setTimeout(() => {
            $('#create_account_dialog').modal('show');
        }, 300);
    }

    /**
     * Function handle click btn 'Oui' [Eligible]
     */
    $("body .section-result").on('click', '.is-eligible .btn-yes, .link-not-eligible', function () {
        cleanData();
        // Scroll top
        $([document.documentElement, document.body]).animate({
            scrollTop: $(".section-header").offset().top - 100
        }, 200);

        // Show Create Account Dialog
        setTimeout(() => {
            $('#create_account_dialog').modal('show');
        }, 300);
    });

    /**
     * Function handle click btn 'Recommencer' [Eligible]
     */
    $("body .section-result").on('click', '.is-eligible .btn-reload', function () {
        location.reload();
    });

    /**
     * Function handle click btn 'Oui' [Not Eligible]
     */
    $("body .section-result").on('click', '.not-eligible .btn-yes', function () {
        cleanData();
        // Scroll top
        $([document.documentElement, document.body]).animate({
            scrollTop: $(".section-attention").offset().top - 100
        }, 200);
    });

    /**
     * Function handle click btn 'Oui, Avec De L'aide' [Not Eligible]
     */
    $("body .section-result").on('click', '.not-eligible .btn-yes-with-help', function () {
        // Scroll top
        $([document.documentElement, document.body]).animate({
            scrollTop: $(".section-attention").offset().top - 100
        }, 200);

        cleanData();

        // open tooltip
        $('.section-aid .icon-tooltip').tooltip('show');
    });

    /**
     * -------------------------------
     *  STEP 4
     * -------------------------------
     */

    /**
     * Method validate Email
     */
    $.validator.addMethod("validateEmail",
        function (value, element) {
            return /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value);
        });

    // setNameInputForm : déplacé vers modules/simulation-dom (dédup web/borne).

    setNameInputForm('form[name="simulation_user"], form[name="simulation"]');

    var trad_email_controle = "Veuillez saisir une adresse e-mail valide.";
    var trad_email_identique = "Les deux email ne sont pas identiques.";
    if (locale === 'tah') {
        trad_email_controle = "Veuillez saisir une adresse e-mail valide. tah";
        trad_email_identique = "Les deux email ne sont pas identiques. tah";
    }
    /**
     * Function handle validate form 'Simulation'
     */
    $("#form_create_account").validate({
        debug: true,
        highlight: function (element) {
            $(element).closest(".form-group").addClass("has-error");
        },
        unhighlight: function (element) {
            $(element).closest(".form-group").removeClass("has-error");
        },
        errorClass: "error",
        errorPlacement: function (error, element) {
            error.appendTo(element.closest(".form-group")); // replace error to closest '.form-group'
        },
        rules: {
            simulation_user_email: {
                required: true,
                validateEmail: true
            },
            simulation_user_confirm_email: {
                required: true,
                equalTo: "#simulation_user_email"
            },
            recaptcha_is_valid:{
                required: true
            }
        },
        messages: {
            simulation_user_email: {
                email: trad_email_controle,
                validateEmail: trad_email_controle,
            },
            simulation_user_confirm_email: {
                email: trad_email_controle,
                equalTo: trad_email_identique
            },
            recaptcha_is_valid:{
                required: "Captcha"
            }
        }
    });

    function displayErrorOnAccountCreated(){
        $('#form_create_account').addClass('d-none');
        $('#simulation_user_submit_user').addClass('d-none');

        var erreur_crea_compte = "Désolé... Une erreur s\'est produit pendant la création de votre compte.<br>Merci de recommencer votre simulation.";
        if(locale === 'tah') {
            erreur_crea_compte = "Te tātarahapa atu nei... ‘ua ‘itehia te hō’ē hape i tō ‘oe ha’amaura’a i tā ‘oe vaira’a parau.<br>A rave fa’ahou i tā ‘oe fa’ahi’ora’a";
        }

        let _text = $('.create-account-error-text');
        let _button = $('.create-account-error');
        _text.html(erreur_crea_compte);
        _text.removeClass('d-none');
        _button.removeClass('d-none');
        _button.on('click', '.btn-reload', function () {
            location.reload();
        });
    }

    var simulationUserId;
    /**
     * Function handle click btn validate
     */
    _body.on('click', '#create_account_dialog .btn-submit', function () {
        var path = `/simulation/account/create`;
        if (tah_lang) {
            path = `/tah/simulation/account/create`;
        }
        const isValid = $('#form_create_account').valid();
        if (!!isValid) {

            var accountInfo = {
                session_id: sessionId,
                email: $('#create_account_dialog #form_create_account #simulation_user_email').val()
            };

            $.ajax({
                url: path,
                type: "POST",
                dataType: "JSON",
                data: accountInfo,
                success: function (data) {
                    if (data.status === 'failed') {
                        displayErrorOnAccountCreated();
                    }
                    if (data.status === 'success') {
                        simulationUserId = data.simulationUserId;

                        $('#create_account_dialog').modal('hide');

                        $('#attention_dialog').modal('show');

                        grecaptcha.reset();
                    }
                },
                error: function (err) {
                    displayErrorOnAccountCreated();
                }
            });
        }
    });

    //RESEND EMAIL ACTION
    $(`#resend_simulation_email`).on('click', function () {
        $(".loader_div").show();
        var url_locale = '/simulation/account/email/resend';
        if (tah_lang) {
            url_locale = '/tah/simulation/account/email/resend';
        }
        var resendEmailInfo = {
            simulationUserId: simulationUserId
        };

        $.when($.ajax({
            url: url_locale,
            type: "POST",
            dataType: "JSON",
            headers: {
                'X-CSRF-TOKEN': $('input[name="_csrf_simulation_token_resend_email"]').attr('value')
            },
            data: resendEmailInfo,
            success: function (data) {
                if (data.status === 'failed') {
                    location.reload();
                }
            },
            error: function (err) {
            }
        })).always(function(){
            $(".loader_div").hide();
        })
    })

    // transformKeyObject extrait dans modules/form-key-transform.js (testé Jest), requis en tête de fichier.

    $('.icon-close-simulation').on('click', function(){
        grecaptcha.reset();
    })
});

function setRecaptchaFormValue() {
    return new Promise(function (resolve, reject) {

        if (grecaptcha === undefined) {
            alert('Recaptcha non definito');
            reject();
        }

        var response = grecaptcha.getResponse(0);
        var recaptchaElement = $("#recaptcha_is_valid"),
            recaptchaError = $('#recaptcha_is_valid-error');
        recaptchaElement.val(response);
        if (recaptchaElement.val().length > 0) {
            recaptchaError.css({'display': 'none'})
        }

        if (!response) {
            alert('Coud not get recaptcha response');
            reject();
        }


    });

}
function setRecaptchaFormValue2() {
    return new Promise(function (resolve, reject) {

        if (grecaptcha === undefined) {
            alert('Recaptcha non definito');
            reject();
        }
        var response = grecaptcha.getResponse(1);
        var recaptchaElement = $("#recaptcha_is_valid"),
            recaptchaError = $('#recaptcha_is_valid-error');
        recaptchaElement.val(response);
        if (recaptchaElement.val().length > 0) {
            recaptchaError.css({'display': 'none'})
        }

        if (!response) {
            alert('Coud not get recaptcha response');
            reject();
        }


    });

}
window.setRecaptchaFormValue = setRecaptchaFormValue;
window.setRecaptchaFormValue2 = setRecaptchaFormValue2;